import "babel-polyfill";
import 'raf/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#def1ea',
      main: '#0a5d66',
      dark: '#3b5847',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#4fc3f7',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

ReactDOM.render(
  <React.Fragment>
    <CssBaseline />
    <MuiThemeProvider theme={theme}>
      <App />
    </MuiThemeProvider>
  </React.Fragment>,
  document.getElementById('root')
);
serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js